import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import GameN from '../pages/game/GameN.vue'/* 游戏新页面 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import MessageBoard from '../pages/mine/MessageBoard.vue'/* 留言板 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import RechargeRecord  from '../pages/mine/RechargeRecord'/* 提现记录 */
import Details from '../pages/mine/details'
import MoneyRecord from '../pages/mine/MoneyRecord'
import Booking from '../pages/lottery/booking.vue'
import Bookingsubmit from '../pages/lottery/bookingsubmit.vue'
import Bookinglist from '../pages/lottery/bookinglist.vue'
import BindUsdt from '../pages/mine/BindUsdt'
import RevenueRecord from '../pages/mine/RevenueRecord'

Vue.use(VueRouter)
const routeTitleMap = {
    home: { zh: '首页', en: 'Home', ja: 'ホーム', kr: '홈' },
    choose: { zh: '选妃', en: 'Choose', ja: 'リソース選択', kr: '리소스 선택' },
    list: { zh: '选妃列表', en: 'Choose List', ja: '選択リスト', kr: '선택 목록' },
    profile: { zh: '选妃详情', en: 'Profile', ja: '詳細', kr: '상세' },
    mine: { zh: '我的', en: 'Mine', ja: 'マイページ', kr: '내 정보' },
    video: { zh: '视频', en: 'Video', ja: '動画', kr: '비디오' },
    game: { zh: '游戏', en: 'Game', ja: 'ゲーム', kr: '게임' },
    game_n: { zh: '广场', en: 'Square', ja: '広場', kr: '광장' },
    login: { zh: '登录', en: 'Login', ja: 'ログイン', kr: '로그인' },
    register: { zh: '注册', en: 'Register', ja: '登録', kr: '회원가입' },
    service_online: { zh: '在线客服', en: 'Online Service', ja: 'オンラインカスタマーサービス', kr: '온라인 고객센터' },
    service_page: { zh: '客服详情', en: 'Service Detail', ja: 'カスタマーサービス詳細', kr: '고객센터 상세' },
    setting: { zh: '设置', en: 'Settings', ja: '設定', kr: '설정' },
    infomation: { zh: '基本信息', en: 'Basic Information', ja: '基本情報', kr: '기본 정보' },
    setname: { zh: '实名认证', en: 'Real Name', ja: '実名変更', kr: '실명 변경' },
    setsex: { zh: '性别', en: 'Gender', ja: '性別修正', kr: '성별 수정' },
    language: { zh: '语言选择', en: 'Language', ja: '言語選択', kr: '언어 선택' },
    recharge: { zh: '充值', en: 'Recharge', ja: 'チャージ', kr: '충전' },
    set_pay_password: { zh: '支付密码', en: 'Payment Password', ja: '決済パスワード管理', kr: '결제 비밀번호 관리' },
    set_login_password: { zh: '登录密码', en: 'Login Password', ja: 'ログインパスワード管理', kr: '로그인 비밀번호 관리' },
    lottery: { zh: '详情页面', en: 'Detail Page', ja: '詳細ページ', kr: '상세 페이지' },
    booking: { zh: '酒店预订', en: 'Hotel Booking', ja: 'ホテル予約', kr: '호텔 예약' },
    booking_submit: { zh: '历史账单', en: 'History Bill', ja: '履歴請求', kr: '이력 청구서' },
    booking_list: { zh: '立即预订', en: 'Book Now', ja: '今すぐ予約', kr: '지금 예약' },
    notice: { zh: '资讯公告', en: 'Notice', ja: 'お知らせ', kr: '공지사항' },
    message_board: { zh: '留言板', en: 'Message Board', ja: '掲示板', kr: '메시지 보드' },
    play_video: { zh: '视频播放', en: 'Play Video', ja: '動画再生', kr: '동영상 재생' },
    setbank: { zh: '银行卡信息', en: 'Bank Card Info', ja: '銀行カード情報', kr: '은행 카드 정보' },
    bind_card: { zh: '绑定银行卡', en: 'Bind Bank Card', ja: '銀行カードを連携', kr: '은행 카드 연결' },
    withdraw: { zh: '提现', en: 'Withdraw', ja: '出金', kr: '출금' },
    personal_report: { zh: '个人报表', en: 'Personal Report', ja: '個人レポート', kr: '개인 보고서' },
    withdraw_record: { zh: '提现记录', en: 'Withdraw Record', ja: '出金記録', kr: '출금 기록' },
    recharge_record: { zh: '充值记录', en: 'Recharge Record', ja: '入金記録', kr: '입금 기록' },
    game_record: { zh: '游戏记录', en: 'Game Record', ja: 'ゲーム記録', kr: '게임 기록' },
    money_record: { zh: '余额明细', en: 'Balance Details', ja: '残高詳細', kr: '잔액 상세' },
    bind_usdt: { zh: '绑定USDT', en: 'Bind USDT', ja: 'USDT連携', kr: 'USDT 연결' }
}

const getRouteTitle = (titleKey) => {
    const lang = localStorage.getItem('lang') || 'en'
    const titleItem = routeTitleMap[titleKey]
    if (!titleItem) {
        return ''
    }
    return titleItem[lang] || titleItem.en || titleItem.zh || ''
}

const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{titleKey:'home'}},
        {path:'/Home',name:'home',component:Home,meta:{titleKey:'home'}},
        {path:'/Choose',name:'choose',component:Choose,meta:{titleKey:'choose'}},
        {path:'/List',name:'list',component:List,meta:{titleKey:'list'}},
        {path:'/Profile',name:'profile',component:Profile,meta:{titleKey:'profile'}},
        {path:'/Mine',name:'mine',component:Mine,meta:{titleKey:'mine'}},
        {path:'/Video',name:'video',component:Video,meta:{titleKey:'video'}},
        {path:'/Game',name:'game',component:Game,meta:{titleKey:'game'}},
        {path:'/GameN',name:'GameN',component:GameN,meta:{titleKey:'game_n'}},
        {path:'/Login',name:'login',component:Login,meta:{titleKey:'login'}},
        {path:'/Register',name:'register',component:Register,meta:{titleKey:'register'}},
        {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{titleKey:'service_online'}},
        {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{titleKey:'service_page'}},
        {path:'/Setting',name:'Setting',component:Setting,meta:{titleKey:'setting'}},
        {path:'/Infomation',name:'Infomation',component:Infomation,meta:{titleKey:'infomation'}},
        {path:'/Setname',name:'Setname',component:Setname,meta:{titleKey:'setname'}},
        {path:'/Setsex',name:'Setsex',component:Setsex,meta:{titleKey:'setsex'}},
        {path:'/Language',name:'Language',component:Language,meta:{titleKey:'language'}},
        {path:'/Recharge',name:'Recharge',component:Recharge,meta:{titleKey:'recharge'}},
        {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{titleKey:'set_pay_password'}},
        {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{titleKey:'set_login_password'}},
        {path:'/Lottery',name:'Lottery',component:Lottery,meta:{titleKey:'lottery'}},
                {path:'/Booking',name:'Booking',component:Booking,meta:{titleKey:'booking'}},
                {path:'/Bookingsubmit',name:'Bookingsubmit',component:Bookingsubmit,meta:{titleKey:'booking_submit'}},
                {path:'/Bookinglist',name:'Bookinglist',component:Bookinglist,meta:{titleKey:'booking_list'}},
        {path:'/Notice',name:'Notice',component:Notice,meta:{titleKey:'notice'}},
        {path:'/MessageBoard',name:'MessageBoard',component:MessageBoard,meta:{titleKey:'message_board'}},
        {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{titleKey:'play_video'}},
        {path:'/Setbank',name:'Setbank',component:Setbank,meta:{titleKey:'setbank'}},
        {path:'/BindCard',name:'BindCard',component:BindCard,meta:{titleKey:'bind_card'}},
        {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{titleKey:'withdraw'}},
        {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{titleKey:'personal_report'}},
        {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{titleKey:'withdraw_record'}},
                {path:'/RechargeRecord',name:'RechargeRecord',component:RechargeRecord,meta:{titleKey:'recharge_record'}},
        {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{titleKey:'game_record'}},
                {path:'/MoneyRecord',name:'MoneyRecord',component:MoneyRecord,meta:{titleKey:'money_record'}},
                {path:'/BindUsdt',name:'BindUsdt',component:BindUsdt,meta:{titleKey:'bind_usdt'}},
    {path:'/detail',name:'Details',component:Details},
	{path:'/RevenueRecord',name:'RevenueRecord',component:RevenueRecord}
	

];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    const titleKey = (to.meta && to.meta.titleKey) || (to.matched[0] && to.matched[0].meta && to.matched[0].meta.titleKey)
    document.title = getRouteTitle(titleKey) || document.title
    next()
})

export default router
